import { useMutation } from "@tanstack/react-query"
import { Button } from "components"
import { mixPanelEvent } from "components/new-stuff/mix-panel/MixPanel"
import NewModalWrapper from "components/new-stuff/ui/modals/NewModalWrapper"
import React, { useState } from "react"
import { paymentSchedulesService } from "services/paymentSchedulesService"
import { useAppNotificationStore } from "stores"
import getIdFromKey from "utils/getIdFromKey"
import { newArchAxiosInstance } from "utils/request"
import { onQueryError } from "utils/utils"
type Props = {
  onClose: () => void
  invalidateQueries: () => void
  open: boolean
  paymentId: string
  x: string
  currency?: string
}

export const RefreshPayment = ({
  onClose,
  open,
  paymentId,
  x,
  invalidateQueries,
  currency,
}: Props) => {
  const { toast } = useAppNotificationStore()
  const [comment, setComment] = useState("")
  const { isLoading: isSubmittingRefreshAll, mutate: submitRefreshAll } =
    useMutation({
      mutationFn: async (body: string) => {
        const data = await paymentSchedulesService.refreshItems(
          paymentId,
          currency
        )

        return data
      },
      onSuccess: (data) => {
        onClose()
        setComment("")
        data?.message && toast.success(data.message)
        mixPanelEvent("pay-schedule-payout-refresh-success")
        invalidateQueries()
      },
      onError: (e) => {
        onClose()
        setComment("")
        onQueryError(e)
      },
    })
  const { isLoading: isSubmittingRefreshSingle, mutate: submitRefreshSingle } =
    useMutation({
      mutationFn: async () => {
        const data = await paymentSchedulesService.refreshItem(
          paymentId,
          currency
        )
        return data
      },
      onSuccess: (data: any) => {
        onClose()
        data?.message && toast.success(data.message)
        invalidateQueries()
        mixPanelEvent("pay-schedule-payout-refresh-success")
      },
      onError: (data: any) => {
        onClose()
        onQueryError(data)
      },
    })

  return (
    <NewModalWrapper
      open={open}
      title="Refresh Payment"
      className="w-[750px]"
      onClose={onClose}
    >
      <div className="px-5 py-3">
        <p className=" text-neutral300 mb-5 text-sm">
          {paymentId == getIdFromKey(x || "")
            ? `All payments will be refreshed in this list`
            : `This payment will be refreshed`}
        </p>
      </div>
      <div className="border py-5 px-6 flex gap-4  justify-end">
        <Button
          color="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          submitting={isSubmittingRefreshSingle || isSubmittingRefreshAll}
          onClick={() => {
            mixPanelEvent("pay-schedule-payout-refresh-init")
            {
              paymentId == getIdFromKey(x || "")
                ? submitRefreshAll(comment)
                : submitRefreshSingle()
            }
          }}
        >
          Refresh
        </Button>
      </div>
    </NewModalWrapper>
  )
}

export default RefreshPayment
